import { useGetActiveUser } from "@/api";
import { SidebarLinksLocal } from "./SidebarButtons";

export const SidebarUser = () => {
  const { data } = useGetActiveUser();
  const initials = getInitials(data?.me.fullName);

  return (
    <SidebarLinksLocal
      data-testid="sidebarUser"
      tooltipText="User Settings"
      route="/user-settings"
      icon={
        <span
          data-testid="sidebarInitials"
          className="uppercase text-[8px] h-5 w-5 rounded-full p-1 text-white dark:text-brand-gray-800 bg-brand-gray-700 dark:bg-brand-gray-100"
        >
          {initials}
        </span>
      }
    />
  );
};

function getInitials(name?: string) {
  if (!name) {
    return "";
  }

  // handles Firstname (Middlename) LastName formatted name
  let split = name.split(" ");
  if (split.length > 1) return split[0][0] + split[split.length - 1][0];

  // handles email formatted name
  const [first] = name.split("@");
  split = first.split(/[^a-z]/i);
  if (split.length > 1) return split[0][0] + split[split.length - 1][0];

  return split[0].slice(0, 2);
}
